import PropTypes from 'prop-types'

export const reportShape = PropTypes.arrayOf(PropTypes.number)
